import React from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface MOCRommsProps {
  onBack: () => void;
}

export default function MOCRomms({ onBack }: MOCRommsProps) {
  return <PayrollRomms onBack={onBack} onComplete={() => {}} workspace="Management Override of Controls" />;
}
